<template>
    <section class="block py-lg-5 py-4 px-0 bg-white" v-if="!isHomeschoolStore">
        <div class="container">
            <div class="text-center1">
                <h4>
                    Weekly Curriculum Map / Standards Correlation
                </h4>
                <p class="text-muted mb-3">
                    Studies Weekly core curriculum simplifies standards coverage with Social Studies ELA integration.
                </p>
            </div>

            <div>
                <b-tabs content-class="mt-3">
                    <b-tab title="Social Studies" active>
                        <div class="btn-group mb-3 w-100">
                            <a
                                v-for="publication in socialStudiesPublications"
                                :key="publication.id"
                                :href="'https://app.studiesweekly.com/online/standards/proxy_correlations/' + publication.sku + '/' + publication.state"
                                class="btn text-center"
                                :class="{
                                        'kindergarten': publication.grade == 0,
                                        'first-grade': publication.grade == 1,
                                        'second-grade': publication.grade == 2,
                                        'third-grade': publication.grade == 3,
                                        'fourth-grade': publication.grade == 4,
                                        'fifth-grade': publication.grade == 5,
                                        'sixth-grade': publication.grade == 6
                                    }"
                                target="_blank"
                            >
                                <template v-if="publication.grade == 0">
                                    K
                                </template>
                                <template v-else>
                                    {{publication.grade}}
                                </template>
                            </a>
                        </div>
                    </b-tab>
                    <b-tab title="Science">
                        <div class="btn-group mb-3 w-100">
                            <a
                                v-for="publication in sciencePublications"
                                :key="publication.id"
                                :href="'https://app.studiesweekly.com/online/standards/proxy_correlations/' + publication.sku + '/' + publication.state"
                                class="btn text-center"
                                :class="{
                                        'kindergarten': publication.grade == 0,
                                        'first-grade': publication.grade == 1,
                                        'second-grade': publication.grade == 2,
                                        'third-grade': publication.grade == 3,
                                        'fourth-grade': publication.grade == 4,
                                        'fifth-grade': publication.grade == 5,
                                        'sixth-grade': publication.grade == 6
                                    }"
                                target="_blank"
                            >
                                <template v-if="publication.grade == 0">
                                    K
                                </template>
                                <template v-else>
                                    {{publication.grade}}
                                </template>
                            </a>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>

            <small class="text-info">
                * Click a grade to view the complete standards coverage.
            </small>

        </div>
    </section>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "Standards",
    props: ['block', 'publications'],
    computed: {
        ...mapState({
             stateData: state => state.stateData.stateData,
        }),
        ...mapGetters({isHomeschoolStore: 'isHomeschoolStore'}),
        socialStudiesPublications () {
            let socialStudiesPublications = []
            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == 'Social Studies') {
                    socialStudiesPublications.push(publication)
                }
            })
            socialStudiesPublications = _.sortBy(socialStudiesPublications, 'language');
            socialStudiesPublications = _.orderBy(socialStudiesPublications, 'grade')
            socialStudiesPublications = _.uniqBy(socialStudiesPublications, 'grade')
            return socialStudiesPublications
        },
        sciencePublications () {
            let sciencePublications = []
            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == 'Science') {
                    sciencePublications.push(publication)
                }
            })
            sciencePublications = _.sortBy(sciencePublications, 'language');
            sciencePublications = _.orderBy(sciencePublications, 'grade')
            sciencePublications = _.uniqBy(sciencePublications, 'grade')
            return sciencePublications
        },
    }

}
</script>

<style scoped>

</style>